import PaymentMethodApi from '@apis/project/PaymentMethodApi';
import { createQueryKeys } from '@lukemorales/query-key-factory';

const paymentQueries = createQueryKeys('paymentMethod', {
    list: () => ({
        queryKey: ['paymentMethods'],
        queryFn: () => PaymentMethodApi.getPaymentMethods(),
    }),
});

export default paymentQueries;
